module.exports = __webpack_public_path__ + "img/img-15.157ac37e.jpg";